import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.array.concat.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { API_URL } from './constant';
import _orderBy from 'lodash/orderBy';
import _deburr from 'lodash/deburr';
import { translateFieldName, objectifyParameters, removeKeyValueFromObject, parametizeURL } from './helpers';

var fetchCategories = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var response, categories;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch(API_URL + '/ino_categories_complete.json', {
              headers: {
                'Content-Type': 'application/json'
              },
              mode: 'cors'
            }).then(function (data) {
              return data.json();
            });

          case 2:
            response = _context.sent;
            categories = [];

            if (!response.error) {
              categories = _orderBy(response, [function (category) {
                return _deburr(category[translateFieldName('name')].toLowerCase());
              }]);
            }

            return _context.abrupt("return", categories);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchCategories() {
    return _ref.apply(this, arguments);
  };
}();

var fetchCategoriesSimple = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    var response, categories;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return fetch(API_URL + '/categories_simple.json', {
              headers: {
                'Content-Type': 'application/json'
              },
              mode: 'cors'
            }).then(function (data) {
              return data.json();
            });

          case 2:
            response = _context2.sent;
            categories = [];

            if (!response.error) {
              categories = _orderBy(response, [function (category) {
                return _deburr(category[translateFieldName('name')].toLowerCase());
              }]);
            }

            return _context2.abrupt("return", categories);

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchCategoriesSimple() {
    return _ref2.apply(this, arguments);
  };
}();

var fetchCertifications = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
    var response, certifications;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return fetch(API_URL + '/certifications.json?supplier_ids[]=1', {
              headers: {
                'Content-Type': 'application/json'
              },
              mode: 'cors'
            }).then(function (data) {
              return data.json();
            });

          case 2:
            response = _context3.sent;
            certifications = [];

            if (!response.error) {
              certifications = response.filter(function (certification) {
                return certification[translateFieldName('name')] !== null;
              });
              certifications = _orderBy(certifications, [function (certification) {
                return _deburr(certification[translateFieldName('name')].toLowerCase());
              }]);
            }

            return _context3.abrupt("return", certifications);

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function fetchCertifications() {
    return _ref3.apply(this, arguments);
  };
}();

var fetchFamiliesForSidebar = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(params) {
    var parameters, families, url, response;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            parameters = objectifyParameters(params);
            parameters = removeKeyValueFromObject(parameters, 'order', 'display', 'families');
            parameters = parametizeURL(parameters);
            families = [];

            if (!(parameters !== null)) {
              _context4.next = 10;
              break;
            }

            url = API_URL + '/products/families.json' + parameters + '&supplier_ids[]=1';
            _context4.next = 8;
            return fetch(url, {
              headers: {
                'Content-Type': 'application/json'
              },
              mode: 'cors'
            }).then(function (data) {
              return data.json();
            });

          case 8:
            response = _context4.sent;

            if (!response.error) {
              families = _orderBy(response, [function (family) {
                return _deburr(family[translateFieldName('name')].toLowerCase());
              }]);
            }

          case 10:
            return _context4.abrupt("return", families);

          case 11:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function fetchFamiliesForSidebar(_x) {
    return _ref4.apply(this, arguments);
  };
}();

var fetchProduct = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(slug) {
    var query, product;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            query = new URLSearchParams({
              supplier_ids: [1]
            });
            _context5.next = 3;
            return fetch(API_URL + '/products/slug/' + slug + '.json?' + query, {
              mode: 'cors'
            }).then(function (data) {
              return data.json();
            });

          case 3:
            product = _context5.sent;
            return _context5.abrupt("return", product);

          case 5:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function fetchProduct(_x2) {
    return _ref5.apply(this, arguments);
  };
}();

var fetchSuppliers = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
    var response, suppliers;
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return fetch(API_URL + '/suppliers.json', {
              headers: {
                'Content-Type': 'application/json'
              },
              mode: 'cors'
            }).then(function (data) {
              return data.json();
            });

          case 2:
            response = _context6.sent;
            suppliers = [];

            if (!response.error) {
              suppliers = _orderBy(response, [function (supplier) {
                return _deburr(supplier[translateFieldName('name')].toLowerCase());
              }]);
            }

            return _context6.abrupt("return", suppliers);

          case 6:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function fetchSuppliers() {
    return _ref6.apply(this, arguments);
  };
}();

var fetchSuppliersForSidebar = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(params) {
    var parameters, suppliers, response;
    return regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            parameters = objectifyParameters(params);
            parameters = removeKeyValueFromObject(parameters, 'order', 'display', 'suppliers');
            parameters = parametizeURL(parameters);
            suppliers = [];

            if (!(parameters !== null)) {
              _context7.next = 9;
              break;
            }

            _context7.next = 7;
            return fetch(API_URL + '/products/suppliers.json' + parameters, {
              headers: {
                'Content-Type': 'application/json'
              },
              mode: 'cors'
            }).then(function (data) {
              return data.json();
            });

          case 7:
            response = _context7.sent;

            if (!response.error) {
              suppliers = _orderBy(response, [function (supplier) {
                return _deburr(supplier[translateFieldName('name')].toLowerCase());
              }]);
            }

          case 9:
            return _context7.abrupt("return", suppliers);

          case 10:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function fetchSuppliersForSidebar(_x3) {
    return _ref7.apply(this, arguments);
  };
}();

var searchProducts = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(term) {
    var response, products;
    return regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return fetch(API_URL + '/products.json?supplier_ids[]=1&q=' + term, {
              headers: {
                'Content-Type': 'application/json'
              },
              mode: 'cors'
            }).then(function (data) {
              return data.json();
            });

          case 2:
            response = _context8.sent;
            products = [];

            if (!response.error) {
              products = response;
            }

            return _context8.abrupt("return", products);

          case 6:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));

  return function searchProducts(_x4) {
    return _ref8.apply(this, arguments);
  };
}();

var fetchFamilies = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(nonce, url) {
    var families, requestUrl, response;
    return regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            requestUrl = "".concat(url, "?action=get_families&nonce=").concat(nonce);
            _context9.next = 3;
            return fetch(requestUrl, {
              headers: {
                'Content-Type': 'application/json',
                'X-WP-Nonce': nonce
              },
              mode: 'cors'
            }).then(function (data) {
              return data.json();
            });

          case 3:
            response = _context9.sent;

            if (!response.error) {
              families = response.data;
            }

            return _context9.abrupt("return", families);

          case 6:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));

  return function fetchFamilies(_x5, _x6) {
    return _ref9.apply(this, arguments);
  };
}();

var fetchSectors = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(nonce, url) {
    var sectors, requestUrl, response;
    return regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            requestUrl = "".concat(url, "?action=get_sectors&nonce=").concat(nonce);
            _context10.next = 3;
            return fetch(requestUrl, {
              headers: {
                'Content-Type': 'application/json',
                'X-WP-Nonce': nonce
              },
              mode: 'cors'
            }).then(function (data) {
              return data.json();
            });

          case 3:
            response = _context10.sent;

            if (!response.error) {
              sectors = response.data;
            }

            return _context10.abrupt("return", sectors);

          case 6:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));

  return function fetchSectors(_x7, _x8) {
    return _ref10.apply(this, arguments);
  };
}();

var fetchMarkets = function fetchMarkets() {
  var markets = [{
    'id': 1,
    'name_en': 'Education',
    'name_fr': 'Éducation',
    'page_en': 'education',
    'page_fr': 'education'
  }, {
    'id': 2,
    'name_en': 'Restauration',
    'name_fr': 'Restauration',
    'page_en': 'restauration',
    'page_fr': 'restauration'
  }, {
    'id': 3,
    'name_en': 'Retailers',
    'name_fr': 'Détaillants',
    'page_en': 'retailers',
    'page_fr': 'detaillants'
  }, {
    'id': 4,
    'name_en': 'Industrial',
    'name_fr': 'Industriel',
    'page_en': 'industrial',
    'page_fr': 'industriel'
  }];
  return markets;
};

var fetchFamily = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(familyId, nonce, url) {
    var family, requestUrl, response;
    return regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            requestUrl = "".concat(url, "?action=get_family&nonce=").concat(nonce, "&id=").concat(familyId);
            _context11.next = 3;
            return fetch(requestUrl, {
              headers: {
                'Content-Type': 'application/json',
                'X-WP-Nonce': nonce
              },
              mode: 'cors'
            }).then(function (data) {
              return data.json();
            });

          case 3:
            response = _context11.sent;

            if (!response.error) {
              family = response;
            }

            return _context11.abrupt("return", family);

          case 6:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));

  return function fetchFamily(_x9, _x10, _x11) {
    return _ref11.apply(this, arguments);
  };
}();

export var Services = {
  fetchCategories: fetchCategories,
  fetchCategoriesSimple: fetchCategoriesSimple,
  fetchCertifications: fetchCertifications,
  fetchFamiliesForSidebar: fetchFamiliesForSidebar,
  fetchProduct: fetchProduct,
  fetchSuppliers: fetchSuppliers,
  fetchSuppliersForSidebar: fetchSuppliersForSidebar,
  searchProducts: searchProducts,
  fetchFamilies: fetchFamilies,
  fetchSectors: fetchSectors,
  fetchMarkets: fetchMarkets,
  fetchFamily: fetchFamily
};